var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarRatingMarked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#E4E7DD"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_24200_73797",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 6,
    width: 20,
    height: 20
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_24200_73797)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9998 20.3958L12.5415 22.4791C12.3887 22.5763 12.229 22.618 12.0623 22.6041C11.8957 22.5902 11.7498 22.5347 11.6248 22.4375C11.4998 22.3402 11.4026 22.2187 11.3332 22.0729C11.2637 21.927 11.2498 21.7638 11.2915 21.5833L12.2082 17.6458L9.14568 15C9.00679 14.875 8.91999 14.7326 8.88527 14.5729C8.85054 14.4132 8.86096 14.2569 8.91652 14.1041C8.97207 13.9513 9.05541 13.8263 9.16652 13.7291C9.27763 13.6319 9.43041 13.5694 9.62485 13.5416L13.6665 13.1875L15.229 9.47913C15.2985 9.31246 15.4061 9.18746 15.5519 9.10413C15.6978 9.02079 15.8471 8.97913 15.9998 8.97913C16.1526 8.97913 16.3019 9.02079 16.4478 9.10413C16.5936 9.18746 16.7012 9.31246 16.7707 9.47913L18.3332 13.1875L22.3748 13.5416C22.5693 13.5694 22.7221 13.6319 22.8332 13.7291C22.9443 13.8263 23.0276 13.9513 23.0832 14.1041C23.1387 14.2569 23.1492 14.4132 23.1144 14.5729C23.0797 14.7326 22.9929 14.875 22.854 15L19.7915 17.6458L20.7082 21.5833C20.7499 21.7638 20.736 21.927 20.6665 22.0729C20.5971 22.2187 20.4998 22.3402 20.3748 22.4375C20.2498 22.5347 20.104 22.5902 19.9374 22.6041C19.7707 22.618 19.611 22.5763 19.4582 22.4791L15.9998 20.3958Z",
    fill: "#587E85"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarRatingMarked);
export default __webpack_public_path__ + "static/media/star-rating-marked.ea502d6231dff246a5e2d1131d49c192.svg";
export { ForwardRef as ReactComponent };